import Icon from '../components/Icon.vue'

Icon.register({
  'euro-sign': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M310.7 413.8C309.4 407.1 302.9 402.9 296.3 404.4 285.6 406.8 268.9 409.8 250.9 409.8 194.1 409.8 148.9 375 129.4 324.4H243.1A12-12 0 0 1 254.8 315L261.2 286.6C262.9 279.1 257.1 272 249.5 272H115.2C114 257.7 113.8 243.7 115.4 229.8H261.9A12-12 0 0 1 273.7 220.3L280.2 190.6C281.8 183.1 276.1 176 268.5 176H130.2C150.8 131 192.9 101 247.8 101 262.3 101 276.4 103.2 285.7 105.1 291.9 106.4 298 102.6 299.7 96.5L311.6 52.1C313.5 45.4 309.2 38.5 302.3 37.2 290.2 34.9 270.7 32 249.6 32 152.5 32 74 92.3 45.1 176H12C5.4 176 0 181.4 0 188V217.8C0 224.4 5.4 229.8 12 229.8H33.6C32.6 243.4 32.4 259 33.4 272H12C5.4 272 0 277.4 0 284V312.4C0 319 5.4 324.4 12 324.4H42.1C67.1 414.7 145.3 480 249.6 480 275.9 480 298.2 475.5 310.7 472.2 316.9 470.6 320.8 464.5 319.5 458.3L310.7 413.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/euro-sign.js
// module id = q/pM
// module chunks = 144